/**
 * Installation / removal notes text for invoice card.
 */

type InstructionEntry = {
  value?: unknown;
  note?: unknown;
  added_at?: string;
};

function getLatestInstructionEntry(instructions: unknown): InstructionEntry | null {
  if (!Array.isArray(instructions) || instructions.length === 0) return null;

  const entries = instructions.filter((inst) => inst && typeof inst === "object") as InstructionEntry[];
  if (entries.length === 0) return null;

  const hasTimestamp = entries.some((entry) =>
    Number.isFinite(Date.parse(String(entry.added_at || "")))
  );

  if (!hasTimestamp) {
    return entries[entries.length - 1] ?? null;
  }

  return [...entries].sort((a, b) => {
    const aTime = Date.parse(String(a.added_at || ""));
    const bTime = Date.parse(String(b.added_at || ""));
    return bTime - aTime;
  })[0] ?? null;
}

/** Latest `additional_instructions` value for installation/removal display. */
export function getLatestAdditionalInstructionValue(instructions: unknown): string {
  const latest = getLatestInstructionEntry(instructions);
  return String(latest?.value ?? "").trim();
}

export function computeInvoiceNotesDisplay(
  isSales: boolean,
  isInstall: boolean,
  isRemoval: boolean,
  effOrder: any
): string | undefined {
  if (isSales) {
    return effOrder?.notes || effOrder?.instructions;
  }
  if (isInstall && Array.isArray(effOrder?.additional_instructions)) {
    return getLatestAdditionalInstructionValue(effOrder.additional_instructions) || undefined;
  }
  if (isRemoval && Array.isArray(effOrder?.additional_instructions)) {
    const fromInstructions = getLatestAdditionalInstructionValue(effOrder.additional_instructions);
    if (fromInstructions) return fromInstructions;
  }
  if (isRemoval && Array.isArray(effOrder?.removal_details?.removal_notes)) {
    const latest = getLatestInstructionEntry(effOrder.removal_details.removal_notes);
    const noteValue = String(latest?.note ?? latest?.value ?? "").trim();
    return noteValue || undefined;
  }
  return undefined;
}
